import { Component, OnInit, ViewChild } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';

import { Mensaje } from '../../../mensaje';
import { environment } from '../../../../environments/environment';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: 'app-articulo-buscar',
  templateUrl: './buscar-precio.component.html'
})

export class BuscarPrecioComponent implements OnInit{
  cargando = false;
  codigo_barras_activo = false;
  tamano = document.body.clientHeight;

  articulo = {
    foto: './assets/128x128.png',
    nombre: '',
    precio: 0,
    galeria: [],
    descripcion: ''
  };

  configuracion = JSON.parse(localStorage.getItem('configuracion'));
  empresa = localStorage.getItem('empresa');
  sucursal = localStorage.getItem('sucursal');
  public articulos_term: string = `${environment.API_URL}/articulos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal}`;

  constructor(
    private crudService: CrudService,
    private http: HttpClient, 
    private _sanitizer: DomSanitizer
    ) { }
  ngOnInit(): void {
  }

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/articulos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`;
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  auto = 0;
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0)
      $('ngui-auto-complete').attr('style', $('ngui-auto-complete').attr('style') + 'z-index:999');
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">${data.nombre} <small style="font-size: .5em; font-style: italic;">${data.categorias ? data.categorias.nombre : 'Ninguna'}</small></h4>
            <h6>
              <strong>Clave: </strong> ${data.clave} <strong>Codigo de barras: </strong> ${data.codigo_barras}
              `;
    html += `<label class="tag is-success" >Presentacion: ${data.presentaciones ? data.presentaciones.nombre : 'Ninguna'} </label>`;

    html += `<label class="tag is-success" >Unidad medida: ${data.unidades_medidas ? data.unidades_medidas.nombre : 'Ninguna'} </label>`;

    html += `<label class="tag is-warning" >Existencia : ${data.existencia}</label>`;

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);

  }

  select_articulo_autocomplete(data) {
    this.cargando = true;
    this.articulo.nombre = data.nombre;
    this.articulo.descripcion = data.descripcion;
    this.articulo.precio = data.articulos_precios[0].precio;
    

    this.cargando = false;
    (<HTMLInputElement>document.getElementById('buscarArticulo')).value = '';
  }

  cambiar_busqueda() {
    this.auto = 0;
    this.codigo_barras_activo = !this.codigo_barras_activo;
    (<HTMLInputElement>document.getElementById('buscarArticulo')).value = '';
    (<HTMLInputElement>document.getElementById('buscarArticulo')).focus;
  }


}
